// The chart palette, as CSS custom properties. Every chart and calculator takes its colors from
// here, never from hex literals, so one stylesheet sets both modes: the values live in
// app/assets/stylesheets/charts.css (light on :root, dark under [data-theme="dark"]), and
// the admin style guide lists them. SVG fill and stroke accept var() directly.
//
// Fixed series order: chart-1 (teal, the idea being illustrated), chart-2 (green, the example's
// data), chart-3 (rust). A fourth group falls back to MUTED rather than a new hue.
export const CHART_1 = "var(--chart-1)";
export const CHART_2 = "var(--chart-2)";
export const CHART_3 = "var(--chart-3)";
export const SERIES = [CHART_1, CHART_2, CHART_3];

export const INK = "var(--chart-ink)";       // values, labels, strong outlines
export const MUTED = "var(--chart-muted)";   // axis text, secondary labels, neutral marks
export const GRID = "var(--chart-grid)";     // gridlines, axis lines, tooltip borders
export const PAPER = "var(--chart-paper)";   // the surface: tooltip boxes, dot rings, label halos, hollow markers
export const ON_FILL = "var(--chart-on-fill)"; // text on the dark end of a ramp

// Fills for regions and boxes.
export const BAND = "var(--chart-band)", BAND_EDGE = "var(--chart-band-edge)"; // a shaded region (the binomial power chart's rejection region)
export const CELL = "var(--chart-cell)";           // an empty table cell
export const NODE_EDGE = "var(--chart-node-edge)"; // a diagram box's outline
export const OBSERVED_FILL = "var(--chart-observed)", LATENT_FILL = "var(--chart-latent)"; // path diagram boxes and ovals
export const TINT_1 = "var(--chart-tint-1)";       // a chart-1 tint for legend swatches of light bands
export const DANGER = "var(--chart-danger)";       // a failed check, always with words

// A sequential ramp: from near-paper (t = 0) to chart-1 (t = 1), or to chart-3 for negatives.
// color-mix in sRGB is the same linear blend the charts used to compute by hand.
export const RAMP_HIGH = "var(--chart-ramp-high)", RAMP_NEG = "var(--chart-ramp-neg)", RAMP_LOW = "var(--chart-ramp-low)";
export const ramp = (t, high = RAMP_HIGH) => {
	const p = Math.max(0, Math.min(1, t)) * 100;
	return `color-mix(in srgb, ${high} ${+p.toFixed(3)}%, ${RAMP_LOW})`;
};
// A series color at an alpha, for legend swatches of translucent fills.
export const alpha = (color, a) => `color-mix(in srgb, ${color} ${+(a * 100).toFixed(3)}%, transparent)`;
